<!-- eslint-disable -->
<template lang="pug">
    portal(to="game-header")
        .game-header
            .game-header__amount-of-actions(v-if="amountOfActions")
                span.amount-of-actions__value
                    | {{ amountOfActionsString }}
            .game-header__rounds-with-time
                .game-header__rounds(v-if="isGameRoundVisible")
                    svg-icon(v-if="isGameRoundPictureVisible" name="flag" size="xxx-large")
                    span.game-header__amount-of-rounds
                        |  {{ $i18n.t('trainer.trainer_gameHeader_round', {all: amountOfRoundsForPlay, played: amountOfPlayedRounds}) }}
                .game-header__time(v-if="time")
                    span.time__value {{ time }}
            .game-header__buttons
                .game-header__button.sound(@click="handleSoundClick")
                    .icon__container.icon__container--sound
                        svg-icon(:key="soundIconName" :name="soundIconName", height="29", width="32")
                .game-header__button(v-if="isToSettingsButtonShown")
                    router-link(:to="settingsRoute")
                        .icon__container
                            svg-icon(name="gear", size="big")
                        cs-button.settings__button(
                            color="white",
                            pattern="primary-outline"
                        )
                            | {{ $i18n.t('trainer.trainer_games_goToSettings') }}
                .game-header__button(v-if="isAnswersButtonShown")
                    .icon__container
                        svg-icon(name="gear", size="big")
                    cs-button.exit__button(
                        color="white",
                        pattern="primary-outline",
                        @click="$emit('finishDictation')"
                    )
                        | {{ $i18n.t('trainer.trainer_game_showAnswers') }}
                .game-header__button
                    router-link(:to="exitRoute")
                        .icon__container
                            svg-icon.icon(name="logout", size="big")
                        cs-button.exit__button(
                            color="white",
                        ) {{ $i18n.t('trainer.trainer_games_exitFromGame') }}
</template>

<script>
    /*eslint-disable*/
    import { mapState } from 'vuex';

    export default {
        props: {
            isAnswersButtonShown: {
                type: Boolean,
                default: false,
            },
            amountOfPlayedRounds: {
                type: Number,
                default: 0,
            },
            amountOfRounds: Number,
            slug: String,
            gameType: String,
            toSettingsRoute: {
                type: Object,
                default: null,
            },
            showRounds: {
                type: Boolean,
                default: false,
            },
            time: {
                type: String,
                default: '',
            },
            isHomework: {
                type: Boolean,
                default: false,
            },
            isBattle: {
                type: Boolean,
                default: false,
            },
            amountOfActions: {
                type: [Number, String],
                default: 0,
            },
        },
        methods: {
            mute() {
                this.$createjs.Sound.muted = true;
            },
            unmute() {
                this.$createjs.Sound.muted = false;
            },
            handleSoundClick() {
                this.$emit('soundStateChanged');
                this.isSoundMuted ? this.unmute() : this.mute();
            },
            setGameRoundPictureVisibility() {
                const gamesWithRoundPicture = ['Chains', 'Scanner', 'Couples', 'Navigator'];
                if (gamesWithRoundPicture.includes(this.slug) || this.isBattle) {
                    this.isGameRoundPictureVisible = window.innerWidth > 1199;
                }
            },
            handleResize: _.debounce(
                function() {
                    this.setGameRoundPictureVisibility();
                },
                500,
                {
                    leading: false,
                    trailing: true,
                }
            ),
        },
        computed: {
            ...mapState({
                lessonConductingTemplate: state => state.trainer.lessonConductingTemplate,
            }),
            isSoundMuted() {
                return this.$createjs.Sound.muted;
            },
            soundIconName() {
                return this.isSoundMuted ? 'sound-off' : 'sound-on';
            },
            settingsRoute() {
                if (this.toSettingsRoute) {
                    return this.toSettingsRoute;
                }
                return { name: 'create:game', query: { slug: this.slug }, params: { gamesType: this.gameType } };
            },
            exitRoute() {
                if (this.isHomework) {
                    return { name: 'dashboard' };
                }
                if (this.lessonConductingTemplate) {
                    return { name: 'lesson-conducting-template:list' };
                }
                return { name: 'trainer:games', params: { gamesType: this.gameType } };
            },
            isGameRoundVisible() {
                return (
                    this.showRounds &&
                    ((this.amountOfRounds && this.amountOfPlayedRounds) || this.amountOfPlayedRounds === 0)
                );
            },
            amountOfRoundsForPlay() {
                return this.amountOfRounds === -1 ? 'ꝏ' : this.amountOfRounds;
            },
            amountOfActionsString() {
                return this.$i18n.t('trainer.trainer_gameFormSetting_actions') + ': ' + this.amountOfActions;
            },
            isToSettingsButtonShown() {
                return (
                    !this.isBattle &&
                    !this.isHomework &&
                    !this.lessonConductingTemplate &&
                    this.$route.name !== 'olympiads:start'
                );
            },
        },
        data() {
            return {
                isGameRoundPictureVisible: false,
            };
        },
        created() {
            this.setGameRoundPictureVisibility();
            window.addEventListener('resize', this.handleResize);
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },
    };
</script>

<style scoped lang="scss">
    .game-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .game-header__rounds-with-time,
    .game-header__amount-of-actions {
        white-space: nowrap;
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
        color: #ffffff;
        display: flex;
        align-items: center;
        margin-right: 10px;
    }
    .game-header__rounds {
        display: flex;
        align-items: center;
        @media screen and (max-width: 359px) {
            .svg-icon {
                display: none;
            }
        }
    }
    .game-header__amount-of-rounds {
        margin-left: 5px;
    }

    .game-header__time {
        border-radius: $border-radius-40;
        color: $x-color-white;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px solid $x-color-white;
        padding: 15px 30px;
        font-weight: normal;
        margin-left: 10px;
        @include media($md) {
            margin-left: 20px;
        }
        span {
            width: 2.7rem;
            text-align: start;
        }
    }

    .game-header__buttons {
        display: flex;
    }
    .game-header__button {
        margin-right: 18px;
        display: flex;
        align-items: center;
        cursor: pointer;
        &:last-child {
            margin-right: 0;
        }
    }

    .icon__container {
        width: 50px;
        height: 50px;
        border: 1px solid $x-color-white;
        border-radius: 50%;
        color: $x-color-white;
        display: flex;
        justify-content: center;
        align-items: center;
        &:hover {
            color: $hsl-color-green-58;
            border-color: $hsl-color-green-58;
            background: $x-color-white;
        }
    }

    .icon__container:not(:last-child) {
        @include media($lg) {
            display: none;
        }
    }

    .settings__button,
    .exit__button {
        display: none !important;
        @include media($lg) {
            display: block !important;
        }
    }
</style>
